import React from 'react';
import { motion } from 'framer-motion';
const sections = [{
  num: '01',
  tag: '6 VOLUMI PDF',
  title: 'Il Percorso Completo',
  items: ['Volume 1: Didattica per Competenze e Normativa — Programmazione annuale, UDA pronte e 33 ore di Educazione Civica già pianificate.', 'Volume 2: Fondamenti di Contabilità e IVA — Dalla prima nota al registro IVA con normativa fiscale aggiornata al 2025/2026.', "Volume 3: Il Bilancio d'Esercizio — Stato Patrimoniale, Conto Economico, riclassificazione e analisi per indici con casi OIC reali.", 'Volume 4: Finanza Aziendale e Controllo di Gestione — Costi, Budget, Break Even Point e analisi delle performance aziendali.', "Volume 5: Diritto Commerciale e Mercati Finanziari — Società di capitali, contratti d'impresa, Borsa e strumenti finanziari.", 'Volume 6: Guida alla Seconda Prova — Maturità 2025/2026 — Simulazioni complete, casi aziendali reali e griglie ministeriali pronte.']
}, {
  num: '02',
  tag: 'CONFORME MIM',
  title: 'Registro del Programma',
  desc: "La soluzione definitiva alla burocrazia: programmazione annuale modulare con UDA già strutturate per monitorare l'avanzamento in 5 minuti. Approvata dal Dirigente al primo invio."
}, {
  num: '03',
  tag: 'PRONTE PER LIM',
  title: 'Slide Economia Visuale',
  desc: 'Lezioni interattive che trasformano la Partita Doppia, il Bilancio e la Finanza Aziendale in immagini logiche immediate. Perfette per la lavagna interattiva e per la Gen Z.'
}, {
  num: '04',
  tag: 'BES & DSA',
  title: 'Recupero & Inclusione',
  desc: 'Schede di recupero rapido pre-verifica e strumenti semplificati per non lasciare indietro nessuno studente. Conformi alla Legge 170/2010.'
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] relative border-t border-brand-orange/10" data-id="element-309">
      <div className="max-w-5xl mx-auto" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-311">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-312">
            Archivio didattico
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-cream mb-3 leading-tight" data-id="element-313">
            Cosa include il{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-314">
              Metodo
            </span>
          </h2>
          <p className="text-base sm:text-lg text-gray-400" data-id="element-315">
            Strumenti digitali in PDF, Word ed Excel pronti da stampare o
            proiettare da oggi stesso.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-316">
          {sections.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/10 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/40 transition-colors" data-id="element-317">
              <div className="absolute -right-4 -top-4 text-7xl sm:text-8xl font-black text-white/5 group-hover:text-brand-orange/10 transition-colors" data-id="element-318">
                {s.num}
              </div>
              <div className="relative z-10" data-id="element-319">
                <div className="inline-block bg-brand-orange text-white text-[10px] sm:text-xs font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-320">
                  {s.num} — {s.tag}
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-brand-cream mb-3 leading-tight" data-id="element-321">
                  {s.title}
                </h3>
                {s.desc && <p className="text-gray-300 text-sm sm:text-base font-medium leading-relaxed" data-id="element-322">
                    {s.desc}
                  </p>}
                {s.items && <ul className="space-y-2 mt-2" data-id="element-323">
                    {s.items.map((it, idx) => <li key={idx} className="text-gray-300 text-sm font-medium leading-relaxed flex gap-2" data-id="element-324">
                        <span className="text-brand-orange shrink-0" data-id="element-325">▸</span>
                        <span data-id="element-326">{it}</span>
                      </li>)}
                  </ul>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}